export var Size = {
  Xs: 'xs',
  Sm: 'sm',
  Md: 'md',
  Lg: 'lg'
};